<template>
    <!-- Presentation -->
        <section id="presentation" class="view-container  presentation">
            <div class="view-content">
                <article class="Presentation-image">
                    <div class="card-container">
                        <div class="card">
                            <div class="gb-home">
                                <img id="screen"
                                    class="presentation-card presentation-card--screen"
                                    :src="currentScreen"
                                    alt="screen">

                                <!--
                                <img src="images/screens/keep/gif1.gif" class="presentation-card  presentation-card--screen     screen-1" alt="presentation">
                                <img src="images/screens/keep/gif2.gif" class="presentation-card  presentation-card--screen     screen-2" alt="presentation">
                                <img src="images/screens/keep/gif3.gif" class="presentation-card  presentation-card--screen     screen-3" alt="presentation">
                                <img src="images/screens/keep/combat.gif" class="presentation-card  presentation-card--screen   screen-7" alt="presentation">
                                <img src="images/screens/keep/badges.gif" class="presentation-card  presentation-card--screen   screen-8" alt="presentation">
                                <img src="images/screens/keep/rythme.gif" class="presentation-card  presentation-card--screen   screen-15" alt="presentation">
                                <img src="images/screens/keep/cartes.gif" class="presentation-card  presentation-card--screen   screen-9" alt="presentation">
                                <img src="images/screens/keep/cartesajouer.gif" class="presentation-card  presentation-card--screen screen-10" alt="presentation">
                                <img src="images/screens/keep/joueurs.gif" class="presentation-card  presentation-card--screen   screen-11" alt="presentation">
                                <img src="images/screens/keep/magmar.gif" class="presentation-card  presentation-card--screen   screen-12" alt="presentation">
                                <img src="images/screens/keep/pokedex.gif" class="presentation-card  presentation-card--screen  screen-13" alt="presentation">
                                <img src="images/screens/keep/starter.gif" class="presentation-card  presentation-card--screen  screen-14" alt="presentation">
                                <img src="images/screens/keep/echange1.gif" class="presentation-card  presentation-card--screen screen-5" alt="presentation">
                                <img src="images/screens/keep/echange2.gif" class="presentation-card  presentation-card--screen screen-6" alt="presentation">
                                <img src="images/screens/keep/corde.gif" class="presentation-card  presentation-card--screen    screen-4" alt="presentation">
                                -->
                                <img src="images/gameboy2.png" class="presentation-card game-boy-sprite" alt="presentation">
                                <img src="images/gameboy3.png" class="presentation-card game-boy" alt="presentation">
                            </div>
                        </div>
                        <div class="slideshow-controls">
                            <button class="slider-btn  slider-precedent"@click="prevScreen">◀</button>
                            <button class="slider-btn  slider-pause" @click="togglePause" :class="{ paused: isPaused }">{{ isPaused ? 'Lecture auto OFF' : 'Lecture auto ON' }}</button>
                            <button class="slider-btn  slider-suivant"@click="nextScreen">▶</button>
                        </div>




                        <div class="slider-indicators">
                            <span
                                v-for="(d, i) in durations"
                                :key="i"
                                class="indicator-dot"
                                :class="{ active: i === index }"
                            ></span>
                        </div>

                    </div>
                </article>
                <article class="Presentation-texte">
                    <h2 class="titre-pokeball">
                        <img src="images/pokeball.svg" alt="pokéball">Découvrez POKéMON Opale, une expérience immersive sur PC et Android qui redéfinit l'aventure POKéMON à travers cinq régions&nbsp;!
                    </h2>
                    <p class="texte-cta">
                        Explorez <span class="bold">60 villes</span> réparties dans <span class="bold">5 régions</span>, chacune avec son atmosphère, ses secrets et ses propres enjeux. <br/>
                        Constituez votre équipe parmi <span class="bold">plus de 600 POKéMON</span>, aventurez-vous dans des zones inédites et obtenez jusqu’à <span class="bold">40 badges</span> à travers des arènes entièrement personnalisées, offrant chacune un style, des mécaniques et des <span class="bold">défis uniques</span>.
                        <br/>
                        <br/>
                        Choisissez votre façon de jouer grâce aux <span class="bold">niveaux de difficulté</span>, ou créez même votre <span class="bold">difficulté personnalisée</span> pour ajuster vos règles, vos limites et votre style de progression.<br/>
                        <br/>
                        Collectez <span class="bold">151 cartes</span> dans les boosters disséminés dans le monde, ou créez votre <span class="bold">deck de cartes à jouer imbattables</span> et complétez votre collection et débloquez des récompenses exclusives pour enrichir votre aventure.<br/>
                        <br/>
                        POKéMON Opale vous propose une <span class="bold">épopée vaste</span>, dense et évolutive, où chaque choix, chaque région et chaque défi <span class="bold">construit votre légende</span>.<br/>
                        Devenez le dresseur que vous avez toujours rêvé d’être.
                        <br/>
                        <br/>
                        <span class="bold">Embarquez pour une aventure épique avec POKéMON Opale et devenez le meilleur dresseur que le monde ait connu&nbsp;!</span>
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                    </p>
                    <h3 class="titre-cta">
                        Restez à l'affût des dernières nouveautés&nbsp;:
                    </h3>
                    <div class="container-link">
                        <div class="cta-container  cta-container--rs">
                            <a href="https://discord.gg/spJs7uGw5D" class="cta  cta-rs">
                                <img src="images/logodiscord.png" class="logo-rs" alt="Discord">
                                Discord
                            </a>
                        </div>
                        <div class="cta-container  cta-container--rs">
                            <a href="https://www.facebook.com/tontonangi" class="cta  cta-rs">
                                <img src="images/logofacebook.png" class="logo-rs" alt="Facebook" >
                                Facebook
                            </a>
                        </div>
                    </div>
                    <div class="cta-container  hide">
                        <a href="#telechargement" class="cta">
                            Télecharger
                        </a>
                    </div>
                </article>
            </div>
        </section>
    <!-- Presentation -->

     
</template>

<script>
export default {
    name: "Presentation",

    data() {
        return {
            index: 0,
            isPaused: false,
            timer: null,

            // --- GIF réels de ton slider ---
            screens: [
                "gif1.gif",
                "gif2.gif",
                "gif3.gif",
                "echange1.gif",
                "echange2.gif",
                "combat.gif",
                "badges.gif",
                "rythme.gif",
                "cartes.gif",
                "cartesajouer.gif",
                "joueurs.gif",
                "magmar.gif",
                "pokedex.gif",
                "starter.gif"
            ],

            // Durées personnalisées
            durations: [
                1500, 1500, 1500, 3000, 2500,
                2500, 4000, 4000, 3000, 3500,
                3000, 3500, 3200, 3800, 4200
            ],

            currentScreen: ""
        };
    },

    mounted() {
        this.loadScreen();
    },

    methods: {
        loadScreen() {
            // Affiche l'image courante
            this.currentScreen = "images/screens/keep/" + this.screens[this.index];

            // --- PRELOAD NEXT IMAGE (optimisation + fluidité) ---
            const preload = new Image();
            preload.src =
                "images/screens/keep/" +
                this.screens[(this.index + 1) % this.screens.length];

            // Ne continue pas si mode pause
            if (this.isPaused) return;

            const duration = this.durations[this.index] || 3000;

            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                this.index = (this.index + 1) % this.screens.length;
                this.loadScreen();
            }, duration);
        },

        togglePause() {
            this.isPaused = !this.isPaused;
            clearTimeout(this.timer);
            if (!this.isPaused) this.loadScreen();
        },

        nextScreen() {
            clearTimeout(this.timer);
            this.index = (this.index + 1) % this.screens.length;
            this.loadScreen();
        },

        prevScreen() {
            clearTimeout(this.timer);
            this.index = (this.index - 1 + this.screens.length) % this.screens.length;
            this.loadScreen();
        }
    }
};


</script>




<style scoped>    
    .presentation{
        width:100%;
        position: relative;
        z-index: 1;
        background-image: url(/public/images/background3.jpg);
        background-size: cover;
        background-attachment: fixed;
        border-top: solid 3px black;
    }
    .presentation-card{
        border-radius: 20px;
        width:100%;
    }
    .card-container {
        perspective: 1000px;
        width: 450px;
        height: 400px;
        margin: 0 auto;
    }
    .card {
        width: 100%;
        height: 100%;
        position: relative;
        transform-style: preserve-3d;
        transition: transform 0.6s;
        filter: drop-shadow(12px 12px 6px #00000055);
    }
    .Presentation-image{
        position: relative;
        top: -170px;
        left: 20px;
    }

    .Presentation-texte{
        width: 100%;
        background-color: #FFF;
        height: fit-content;
        padding: 30px 30px 30px 50px;
        border-top: solid 1px #000000;
        border-bottom: solid 1px #000000;
        border-radius: 20px;
    }
    .gb-home{
        position: relative;
    }
    .presentation-card--screen{
        position: absolute;
        width: 86%;
        left: 7%;
        top: 26px;
        opacity: 1;
        z-index: -1;
    }

    .view-container {
        padding-top: 130px;
        padding-bottom: 130px;
    }
    .game-boy{
        position: absolute;
        top: 0;
        left: 0;
        animation : gameboy 0.4s infinite;
    }

    .logo-rs {
        width: 20px;
        height: 20px;
        vertical-align: middle;
        top: -2px;
        position: relative;
        left: -5px;
    }
    .slideshow-controls{
        position: absolute;
        width: 250px;
        left: 99px;
        top: 320px;
        background: #272e38;
        border-radius: 10px;
        padding: 1px;
    }
    .slider-btn{
        background-color: #3153c1;
        color: #ffffff;
        border: none;
        height: 33px;
        padding: 5px 10px;
        margin: 5px;
        border-radius: 5px;
        cursor: pointer;
        font-size: 16px;
        transition: background-color 0.3s;
        text-align: center;
        font-family: "Rubik", sans-serif;
    }
    .slider-pause{
        width:150px;
        color: #ffffff;
    }
    .slider-btn:hover {
        opacity: 0.8;
    }
    .slider-pause{
        background: #116451;
    }
    .slider-pause.paused{
        background: #7c2126;
    }


    .texte-cta{
        padding-bottom:0;
    }


    .slider-indicators {
        display: flex;
        gap: 6px;
        justify-content: center;
        margin-top: 10px;
        position: absolute;
        top: 303px;
        left: 142px;
    }

    .indicator-dot {
        width: 6px;
        height: 6px;
        background: #6b6464;
        border-radius: 2px; /* tu peux mettre 0 si tu veux du carré parfait */
        opacity: 0.6;
        transition: background 0.2s, opacity 0.2s;
    }

    .indicator-dot.active {
        background: #fff;
        opacity: 1;
    }


    .view-content {
        display: flex;
        justify-content: center;
        align-items: center;
        width: calc(100% - 82px);
        max-width: 1600px;
        margin: auto;
        background: #a59e5a40;
        backdrop-filter: blur(15px);
        -webkit-backdrop-filter: blur(15px);
        border-radius: 50px;
        padding: 40px 40px;
        border: solid 1px #c1bc7c;
    }


    .container-link{
        display: flex;
        gap: 20px;
        margin-top: 20px;
        padding-bottom: 20px;
    }


    @keyframes gameboy {
        0% {
            opacity: 0;
        }
        50% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }

    @keyframes scroll-grid {
        0% {
            background-position: 30px 10px;
        }
        100% {
            background-position: 0px 0px;
        }
    }
    @media screen and (max-width: 1200px){
        .view-content {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            max-width: 1600px;
            margin: auto;
            flex-wrap: wrap;
        }
        .view-container{
            padding-bottom: 0px;
            width: 100% !important;
        }
        .view-content{
            width:100% !important;
        }
        .Presentation-texte, .view-content, .view-container, .card-container, .card{
            border:none;
            border-radius: 0;
            filter: none;
        }
        .Presentation-texte{
            padding-top: 200px !important;
        }
        .card-container{
            filter: none;
        }
        .titre-logo{
            left: 10%;
            width: 80%;
        }
        .slideshow-controls{
            left:103px;
        }
        .logo-rs{
            left: 38%;
        }
        .cta-container--rs{

        }

        .cta-rs{
            display: flex;
            flex-direction: column;
        }
    }





    
    @media screen and (max-width: 900px){
        .view-content {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            max-width: 1600px;
            margin: auto;
            flex-wrap: wrap;
        }
        .view-container{
            padding-bottom: 0px;
            width: 100% !important;
        }
        .game-boy, .game-boy-sprite{
            display: none;
        }
        
        .view-content{
            width:100% !important;
        }
        .Presentation-texte, .view-content, .view-container, .card-container, .card{
            border:none;
            border-radius: 0;
            filter: none;
        }
        .Presentation-texte{
            padding-top: 100px !important;
        }
        .card-container{
            filter: none;
        }
        .titre-logo{
            left: 10%;
            width: 80%;
        }
        .slideshow-controls{
            left:0;
        }
        .card-container{
            filter: none;
            width: 100%;
            height: 70vw;
        }
        
        .logo-rs{
            left: 38%;
        }

        .cta-rs{
            display: flex;
            flex-direction: column;
        }
        .presentation-card--screen{
            position: absolute;
            width: 80%;
            left: 11%;
            top: 0;
            opacity: 1;
            z-index: -1;
        }
        .slideshow-controls, .slider-indicators{
            top: auto;
            left: 0;
            position: relative;
            margin: auto;
        }
        .slideshow-controls{
            top: -11px;
            left: 0;
            position: relative;
            margin: auto;
            WIDTH: 100%;
            text-align: center;
            background: #212121;
        }
        .slider-indicators{
            margin-top: 10px;
            top: -101px;
            background: #212121;
            width: fit-content;
            padding: 5px;
            border-radius: 7px;
        }
        .slider-btn{
            width: 44px;
            height: 44px;
        }
        .slider-pause{
            width: fit-content;
            height: 44px;
        }
        .Presentation-image{
            width: 90%;
            filter: none;
            left: 0;
            top:0;
            padding-top: 20vw;
        }
    }
    
</style>